<template>
    <div class="mailing-list">

        <div class="text">
            <div class="icon">
                <i class="fas fa-envelope-open-text"></i>
            </div>
            <div>
                <h2>Stay in touch</h2>
                Join the <b>NLCAA</b> mailing list
            </div>
        </div>

        <div class="is-subscribed" v-if="isSubscribed">
            <i class="far fa-check-circle"></i>
            You are subscribed!
        </div>

        <form action="#" v-else>
            <div class="input-group">
                <label for="mailing-list-input" class="d-none">Email</label>
                <input id="mailing-list-input" type="text" v-model="form.email" class="form-control" placeholder="Enter your email address" aria-label="Your Email">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="submit()">
                        <span>Subscribe</span>
                    </button>
                </div>
            </div>
        </form>

    </div>
</template>
<script>
    export default {

        data() {
            return {
                isSubscribed: false,
                form: new Form({
                    email: '',
                }).dontClear(),
            }
        },

        mounted(){
            this.isSubscribed = Storage.get('mailing-list');
        },

        methods: {
            submit() {
                this.form.post(`/mailing-list`).then(response => {
                    Storage.put(`mailing-list`, this.form.email);
                    this.isSubscribed = this.form.email;
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },
        }
    }
</script>